module.exports = __webpack_public_path__ + "img/ia-03-2.58644302.png";